<app-header></app-header>
<div class="tracker-detail pt0">
    <div class="headerbanner" *ngIf="!isMapDirection">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="font16 mb-1" *ngIf="distanceInKm">Distance in km: {{this.distanceInKm | number:'2.2-2'}}</h4>
                    <app-map></app-map>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="innercard mb50">
                    <p class="font24  mb10 center lh30" translate>lblWelcomeToDigitalCheckIn</p>
                    <p class="font18 center" translate></p>
                    <div class="mt30">
                        <ul class="lst1">
                            <li class="lastchild">
                                <div class="row">
                                    <div class="col p-0">
                                        <a href="javascript:void(0);" class="center blk py-3" (click)="startCheckIn();" translate>
                                            <span class="circle"><em class="fa blink fa-mobile-alt
                                         clrlightgreen"></em></span>lblStartCheckIn<em class="fas fa-angle-right ml5 font16
                                      txtblue"></em></a>
                                    </div>
                                    <div class="col p-0 border-left" *ngIf="isMapDirection">
                                        <a href="javascript:void(0);" class="center blk py-3" translate (click)="openMapDirection();">
                                            <span class="circle"><em class="fa fa-map clrblue"></em></span>
                                            <span translate>lblDealerDirection</span><em class="fas fa-angle-right ml5 font16
                                            txtblue"></em>
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li class="lastchild">
                                <a href="javascript:void(0);" (click)="openVirtualTour(virtualTour);" class="center blk py-3" translate>
                                    <span class="circle"><em class="fa fa-video
                                 clrlightblue"></em></span>lblDeliverPickUpCarWithKeydrop<em class="fas fa-angle-right ml5
                              font16 txtblue"></em></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</div>
<app-footer-site-info></app-footer-site-info>

<ng-template #virtualTour let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblDeliverPickUpCarWithKeydrop</h4>   
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="prelvideo">
            <iframe width="100%" height="100%" [src]="transform()" style="border: 0;" title="AF Video" allowfullscreen></iframe>
        </div>
    </div>
</ng-template>